import { Calendar, LayoutGrid } from "lucide-react";

const viewClass = (isActive) =>
  `flex items-center justify-center w-[30px] h-[30px] p-0 rounded-lg border-0 transition-all ${
    isActive
      ? "bg-[#0F172A] text-white shadow-md"
      : "bg-[#F8FAFC] text-[#334155] hover:bg-gray-100"
  }`;

export default function ViewSwitcher({ activeView, setActiveView }) {
  return (
    <div className="hidden md:inline-flex items-center gap-1 p-1 bg-white rounded-xl border-[1px] border-solid border-[#E2E8F0] shadow-sm w-fit">
      <button
        onClick={() => setActiveView("grid")}
        className={viewClass(activeView === "grid")}
      >
        <LayoutGrid size={15} />
      </button>
      <button
        onClick={() => setActiveView("calendar")}
        className={viewClass(activeView === "calendar")}
      >
        <Calendar size={15} />
      </button>
    </div>
  );
}
